<div class="wrapper wrapper-content mtv-parcels-page row">
    <div class="ibox mainPartPage">
        <div class="ibox-content">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Instructions'"></filter>
                </div>

                <div class="col-sm-3 input-group-btn pull-right">
                    <button class="btn btn-w-m btn-primary pull-right" style="border-radius: 3px 0 0 3px;" type="button"
                        (click)="frontDeskInstructionsService.isFrontDeskInstructionsModalShow = true">
                        <i class="fa fa-plus-circle"></i> New Instruction
                    </button>
                </div>

            </div>
            <tabs-wrapper>
                <tab-item [active]="true" [tabId]="'allInstructions'"
                    [ngClass]="{'sk-loading' : frontDeskInstructionsService.showSpinner}">
                    <front-desk-instructions-list></front-desk-instructions-list>
                </tab-item>
                <pagination [total]="frontDeskInstructionsService.data?.total"></pagination>
                <spinner [spinnerShow]="frontDeskInstructionsService.showSpinner"></spinner>
            </tabs-wrapper>
        </div>
    </div>
</div>

<add-instructions-modal *ngIf="frontDeskInstructionsService.isFrontDeskInstructionsModalShow"
    [frontDeskInstructions]="true"></add-instructions-modal>


// WEBPACK FOOTER //
// /app/src/app/views/front-desk-instructions/front-desk-instructions.component.html